import React, { useContext, useState } from 'react';
import { Pressable } from 'react-native';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPrint } from '@fortawesome/free-solid-svg-icons';

import AuthContext from 'app/src/contexts/AuthContext';
import { rest } from 'app/src/utils/rest';

const Print = ({ path, filename }) => {
  const { credentials } = useContext(AuthContext);
  const [printing, setPrinting] = useState(false)

  const download = () => {
    setPrinting(true);

    const options = {
      credentials,
      path,
      headers: { Accept: 'application/pdf' }
    };

    rest(options).then(response => {
      response.blob().then(blob => {
        const fileURL = window.URL.createObjectURL(blob);
        const tab = window.open();
        tab.location.href = fileURL;
      });

      setPrinting(false);
    });
  };

  return (
    <Pressable onPress={download}>
      <FontAwesomeIcon icon={faPrint} color={ printing ? 'gray' : 'green' } />
    </Pressable>
  )
};

export default Print;
